import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const InterestedClients: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const formUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfzVEfwjZuMAxqQH8LSx6Q7qoji6r6XE0SA-o6zHZtT5oA0XA/viewform?embedded=true";

  return (
    <section
      className="relative w-full overflow-hidden bg-white px-4 py-20 dark:bg-slate-950 sm:px-6"
      id="learn-more"
    >
      <div className="absolute left-8 top-16 hidden h-24 w-24 rotate-12 rounded-2xl border border-primary/10 bg-primary/5 hs-float lg:block" />
      <div className="absolute bottom-16 right-8 hidden h-28 w-28 rounded-full border border-emerald-300/20 bg-emerald-300/10 hs-soft-pulse lg:block" />
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr_1.05fr]">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary dark:text-pink-200">
              {t("requestPos.eyebrow")}
            </p>
            <h2 className="mt-3 text-3xl font-black tracking-tight text-slate-950 sm:text-5xl dark:text-white">
              {t("requestPos.title")}
            </h2>
            <p className="mt-5 text-lg leading-8 text-slate-600 dark:text-slate-300">
              {t("requestPos.description")}
            </p>

            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              {[
                ["01", t("requestPos.stepBusiness")],
                ["02", t("requestPos.stepSetup")],
                ["03", t("requestPos.stepFollowUp")],
              ].map(([step, label]) => (
                <div
                  key={step}
                  className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900"
                >
                  <div className="text-sm font-black text-primary dark:text-pink-200">
                    {step}
                  </div>
                  <div className="mt-2 text-sm font-bold text-slate-800 dark:text-white">
                    {label}
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              className="mt-8 inline-flex items-center justify-center rounded-xl bg-primary px-7 py-3.5 text-base font-bold text-white shadow-lg shadow-primary/20 transition hover:-translate-y-0.5 hover:bg-[#6d1f55]"
            >
              {t("requestPos.openForm")}
            </button>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-r from-primary/10 via-pink-300/10 to-emerald-300/10 blur-2xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-3 shadow-2xl shadow-slate-900/10 dark:border-slate-800 dark:bg-slate-900">
              <div className="rounded-[1.5rem] bg-slate-950 p-5 text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm font-bold text-pink-200">
                      {t("requestPos.cardEyebrow")}
                    </div>
                    <div className="mt-1 text-2xl font-black">
                      {t("requestPos.cardTitle")}
                    </div>
                  </div>
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10">
                    <svg
                      className="h-6 w-6"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M4 7h16M7 4v6M17 4v6M6 12h12M6 16h8M5 20h14V7H5v13Z" />
                    </svg>
                  </div>
                </div>
                <div className="mt-8 grid gap-4">
                  {[
                    [t("requestPos.profileTitle"), t("requestPos.profileDetail")],
                    [t("requestPos.workflowTitle"), t("requestPos.workflowDetail")],
                    [t("requestPos.supportTitle"), t("requestPos.supportDetail")],
                  ].map(([title, detail]) => (
                    <div
                      key={title}
                      className="rounded-2xl border border-white/10 bg-white/[0.06] p-4"
                    >
                      <div className="flex items-center justify-between gap-4">
                        <div>
                          <div className="font-bold">{title}</div>
                          <div className="mt-1 text-sm text-slate-300">
                            {detail}
                          </div>
                        </div>
                        <span className="h-3 w-3 rounded-full bg-emerald-400" />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-8 rounded-2xl bg-white p-4 text-slate-950">
                  <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                    {t("requestPos.nextStep")}
                  </div>
                  <div className="mt-2 text-lg font-black">
                    {t("requestPos.modalReady")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/75 px-4 py-6 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-labelledby="request-pos-title"
        >
          <div className="relative flex max-h-[92vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-slate-950">
            <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-slate-800">
              <div>
                <h3
                  id="request-pos-title"
                  className="text-lg font-black text-slate-950 dark:text-white"
                >
                  {t("requestPos.modalTitle")}
                </h3>
                <p className="text-sm text-slate-500 dark:text-slate-400">
                  {t("requestPos.modalSubtitle")}
                </p>
              </div>
              <button
                type="button"
                onClick={() => setIsModalOpen(false)}
                className="rounded-full border border-slate-200 p-2 text-slate-600 transition hover:bg-slate-100 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
                aria-label="Close request form"
              >
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </button>
            </div>
            <iframe
              title="Interested Clients"
              src={formUrl}
              className="h-[76vh] w-full bg-white"
              frameBorder="0"
            >
              Loading...
            </iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default InterestedClients;
